import { IDL } from "@dfinity/agent";

export const FTFactory: IDL.InterfaceFactory = ({ IDL }: { IDL: any }) => {
  const Index = IDL.Nat;
  const DiffBalance = IDL.Record({ after: IDL.Nat, before: IDL.Nat });
  const EventKind = IDL.Variant({
    transferKind: IDL.Record({
      recipientDiffBalance: DiffBalance,
      senderDiffBalance: DiffBalance,
      memo: IDL.Text,
      recipient: IDL.Principal,
      sender: IDL.Principal,
      amount: IDL.Nat,
    }),
    approveKind: IDL.Record({
      approverApprovalDiff: DiffBalance,
      approver: IDL.Principal,
      amount: IDL.Nat,
      spender: IDL.Principal,
    }),
    initializationKind: IDL.Record({
      admin: IDL.Principal,
      supply: IDL.Nat,
      caller: IDL.Principal,
      decimal: IDL.Nat8,
      symbol: IDL.Text,
    }),
    creationKind: IDL.Record({ deployer: IDL.Principal }),
    transferFromKind: IDL.Record({
      recipientDiffBalance: DiffBalance,
      memo: IDL.Text,
      recipient: IDL.Principal,
      approver: IDL.Principal,
      amount: IDL.Nat,
      spender: IDL.Principal,
      approverDiffBalance: DiffBalance,
    }),
    updateAdminKind: IDL.Record({
      admin: IDL.Principal,
      caller: IDL.Principal,
    }),
  });
  const Event = IDL.Record({
    time: IDL.Int,
    index: Index,
    eventKind: EventKind,
  });
  const FungibleToken = IDL.Service({
    admin: IDL.Func([], [IDL.Principal], ["query"]),
    approval: IDL.Func([IDL.Principal, IDL.Principal], [IDL.Nat], ["query"]),
    approvals: IDL.Func(
      [IDL.Principal],
      [IDL.Vec(IDL.Tuple(IDL.Principal, IDL.Nat))],
      ["query"]
    ),
    approve: IDL.Func([IDL.Principal, IDL.Nat], [], []),
    balanceOf: IDL.Func([IDL.Principal], [IDL.Nat], ["query"]),
    canisterBalance: IDL.Func([], [IDL.Nat], ["query"]),
    decimal: IDL.Func([], [IDL.Nat8], ["query"]),
    getEventRangeIndex: IDL.Func(
      [Index, Index],
      [IDL.Vec(IDL.Opt(Event))],
      ["query"]
    ),
    getIndex: IDL.Func([], [Index], ["query"]),
    init: IDL.Func([IDL.Principal, IDL.Nat, IDL.Nat8, IDL.Text], [], []),
    isFTv1: IDL.Func([], [IDL.Bool], ["query"]),
    isInitialized: IDL.Func([], [IDL.Bool], ["query"]),
    supply: IDL.Func([], [IDL.Nat], ["query"]),
    symbol: IDL.Func([], [IDL.Text], ["query"]),
    topUp: IDL.Func([], [IDL.Nat], []),
    transfer: IDL.Func([IDL.Principal, IDL.Nat, IDL.Text], [Index], []),
    transferFrom: IDL.Func(
      [IDL.Principal, IDL.Principal, IDL.Nat, IDL.Text],
      [Index],
      []
    ),
    updateAdmin: IDL.Func([IDL.Principal], [], []),
    whoami: IDL.Func([], [IDL.Principal], []),
  });
  return FungibleToken;
};

export default FTFactory;
